import { clsx } from "clsx";
import { HTMLAttributes } from "react";

export const Spinner = ({
  className,
  size = "md",
  ...props
}: HTMLAttributes<HTMLDivElement> & { size?: "xs" | "sm" | "md" | "lg" }) => {
  const sizes = {
    xs: "h-1.5 w-1.5",
    sm: "h-2 w-2",
    md: "h-2.5 w-2.5",
    lg: "h-3 w-3",
  };

  const sizeSpacing = {
    xs: "space-x-1",
    sm: "space-x-1.5",
    md: "space-x-2",
    lg: "space-x-2.5",
  };
  return (
    <div
      data-testid="spinner"
      className={clsx(sizeSpacing[size], "flex justify-center items-center w-full pt-2", className)}
      {...props}
    >
      <span className="sr-only">Loading...</span>
      <div className={clsx(sizes[size], "bg-brand-500 rounded-full animate-bounce [animation-delay:-0.3s]")}></div>
      <div className={clsx(sizes[size], "bg-brand-500 rounded-full animate-bounce [animation-delay:-0.15s]")}></div>
      <div className={clsx(sizes[size], "bg-brand-500 rounded-full animate-bounce")}></div>
    </div>
  );
};
